import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConnectivityNoticeService } from '../../services/connectivity-notice/connectivity-notice.service';

/**
 * @description
 * Blocking layer shown while there is no connectivity in the browser/PWA, below the connectivity
 * toast.
 *
 * In the browser a lazy chunk that could not be fetched stays broken until the document is
 * reloaded, so the interaction is blocked to avoid those failed fetches in the first place. It has
 * no content on purpose: the message is the toast, which stays visible above this layer. It is not
 * rendered on native platforms, where the app keeps working with the data already loaded.
 */
@Component({
  selector: 'lib-offline-overlay',
  templateUrl: './offline-overlay.component.html',
  styleUrls: ['./offline-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OfflineOverlayComponent {
  protected readonly isVisible = inject(ConnectivityNoticeService).isOverlayVisible;
}
